"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICING_TIMEOUT = exports.IntendedActions = exports.PageContext = exports.Commands = void 0;
var Commands;
(function (Commands) {
    Commands["ELIGIBILITY_V2"] = "eligibilityV2";
    Commands["ELIGIBILITY"] = "eligibility";
    Commands["ELIGIBILITY_WITH_AUTH_STATE"] = "getAuthState,eligibility";
    Commands["ELIGIBILITY_WITH_TAX"] = "eligibility,getTaxQuote";
    Commands["ELIGIBILITY_WITH_TAX_FRAUD"] = "eligibility,vpnCheck,getTaxQuote";
    Commands["ELIGIBILITY_V2_PAUSED"] = "eligibilityV2WithOrderDetailsPausedState";
    Commands["ELIGIBILITY_V2_PAUSED_PENDING_CANCEL"] = "eligibilityV2WithOrderDetailsPausedPendingCancelState";
    Commands["GET_NEXT_INTERACTION"] = "getAuthState,mopDetails,determineNextInteraction";
    Commands["ELIGIBILITY_V2_PENDING_PAUSE"] = "eligibilityV2WithOrderDetailsPendingPauseState";
    Commands["ELIGIBILITY_PAUSED_PENDING_CANCEL"] = "getAuthState,eligibility,withOrderDetailsPausedPendingCancelPendingPauseState,mopDetails,getTaxQuote";
    Commands["ELIGIBILIY_CANCELLED"] = "getAuthState,eligibility,getMopSummaryResubscribeState";
    Commands["ELIGIBILITY_V2_ACTIVE_RENEWAL"] = "eligibilityV2WithOrderDetailsActiveStates";
    Commands["ELIGIBILITY_V2_ALL_ORDER_DETAILS"] = "eligibilityV2WithOrderDetailsAllStates";
    Commands["ELIGIBILITY_V2_WITH_TAX"] = "eligibilityV2WithTax";
    Commands["ELIGIBILITY_V2_WITH_VPN"] = "eligibilityV2,vpnCheck";
    Commands["ELIGIBILITY_WITH_TAX_AND_GEO_RELATED_FRAUD"] = "eligibility,vpnCheck,getTaxQuote,linkSharingAbuseCheck";
})(Commands = exports.Commands || (exports.Commands = {}));
var PageContext;
(function (PageContext) {
    PageContext["PRODUCT_PLAN"] = "productPlan";
    PageContext["CHEGG_STUDY_RESUBSCRIBE"] = "chegg_study-resubscribe";
    PageContext["BUNDLE_RESUBSCRIBE"] = "bundle-resubscribe";
})(PageContext = exports.PageContext || (exports.PageContext = {}));
var IntendedActions;
(function (IntendedActions) {
    IntendedActions["JOIN"] = "JOIN";
    IntendedActions["RESUME"] = "RESUME";
    IntendedActions["REVOKE_PENDING_PAUSE"] = "REVOKE_PENDING_PAUSE";
    IntendedActions["REVOKE_PENDING_CANCEL"] = "REVOKE_PENDING_CANCEL";
    IntendedActions["RESUBSCRIBE"] = "RESUBSCRIBE";
    IntendedActions["UPGRADE"] = "UPGRADE";
    IntendedActions["DOWNGRADE"] = "DOWNGRADE";
})(IntendedActions = exports.IntendedActions || (exports.IntendedActions = {}));
exports.PRICING_TIMEOUT = 10000;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/pricingApi/interfaces.js
// module id = 626
// module chunks = 11